const dataLayer = window.dataLayer || [];

export const trackEvent = ({
	event,
	target,
	value = undefined,
	key = "selected",
}) => {
	dataLayer.push({
		event,
		app: target,
		[key]: value,
	});
};

window.dataLayer = dataLayer;
